module.exports = __webpack_public_path__ + "assets/images/logo-intro_14238f9e9bc912e394087a17b2fc34a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-intro.png
// module id = 131
// module chunks = 0